var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-tour-id":"samples-register-standard-form"}},[_c('div',{staticClass:"input-full"},[_c('div',[_c('div',{staticClass:"card-content padding"},[_c('div',{staticClass:"form-container"},[_c('form',[_c('DxForm',{ref:"splRegisterForm",attrs:{"label-location":"top","col-count":10,"form-data":_vm.formData,"element-attr":{ class: 'standard-sample-register-form' }}},[_c('DxGroupItem',{attrs:{"col-count":10,"col-span":10}},[_c('DxItem',{attrs:{"data-field":"CodPresupuesto","editor-type":"dxSelectBox","css-class":"sample-register-first-row-lower","is-required":true,"col-span":2,"editor-options":{
                    dataSource: _vm.store,
                    displayExpr: 'CodOfferTitle',
                    valueExpr: 'CodPresupuesto',
                    searchEnabled: true,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class:
                          'standard-codPresupuesto-select-dropdown',
                      },
                    },
                  },"validation-rules":[
                    {
                      type: 'required',
                      message: _vm.$t('fillRequiredFields'),
                    },
                  ]}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.budget')}})],1),_vm._v(" "),_c('DxItem',{attrs:{"editor-type":"dxDateBox","data-field":"SamplingDate","is-required":true,"col-span":2,"editor-options":{
                    type: 'datetime',
                    displayFormat:
                      _vm.$helpers.getDateFormat(_vm.company) + ' HH:mm',
                    applyValueMode: 'instantly',
                    elementAttr: {
                      class: 'samples-register-datetime-field',
                    },
                    dropDownOptions: {
                      wrapperAttr: {
                        class: 'samples-register-datetime-popup',
                      },
                    },
                  },"validation-rules":[
                    {
                      type: 'required',
                      message: _vm.$t('fillRequiredFields'),
                    },
                  ]}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.samplingDateAndTime')}})],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"FamiliaTM","editor-type":"dxSelectBox","css-class":"sample-register-first-row-lower","is-required":true,"col-span":2,"editor-options":{
                    disabled: _vm.familiDisabled,
                    dataSource: {
                      store: _vm.familiesFiltered,
                      sort: { selector: 'FamiliaTM', desc: false },
                    },
                    displayExpr: 'FamiliaTM',
                    valueExpr: 'idFamiliaTM',
                    searchEnabled: true,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class: 'standard-familiaTM-select-dropdown',
                      },
                    },
                  },"validation-rules":[
                    {
                      type: 'required',
                      message: _vm.$t('fillRequiredFields'),
                    },
                  ]}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.family')}})],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"Descripcion","editor-type":"dxSelectBox","css-class":"sample-register-first-row-type","is-required":true,"col-span":2,"editor-options":{
                    disabled: _vm.sampleTypesDisabled,
                    dataSource: {
                      store: _vm.sampletypesUi,
                      sort: {
                        selector: 'Descripcion',
                        desc: false,
                      },
                    },
                    displayExpr: 'Descripcion',
                    valueExpr: 'this',
                    searchEnabled: true,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class:
                          'standard-sampleTypes-select-dropdown',
                      },
                    },
                  },"validation-rules":[
                    {
                      type: 'required',
                      message: _vm.$t('fillRequiredFields'),
                    },
                  ]}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.sampleType')}})],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"SubTipoMuestra","editor-type":"dxSelectBox","col-span":2,"editor-options":{
                    disabled: _vm.subSampleTypeVisible,
                    dataSource: {
                      store: _vm.subSampleType,
                      sort: {
                        selector: 'Descripcion',
                        desc: false,
                      },
                    },
                    displayExpr: 'Descripcion',
                    valueExpr: 'idSubTipoMuestra',
                    searchEnabled: true,
                    elementAttr: { title: _vm.formData.SubTipoMuestra },
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class:
                          'standard-subSampleType-select-dropdown',
                      },
                    },
                  }}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.sampleSubtype')}})],1)],1),_vm._v(" "),_c('DxGroupItem',{attrs:{"col-count":_vm.chlorineDisabled ? 24 : 5,"col-span":10}},[_c('DxItem',{attrs:{"data-field":"cloroResidual","editor-type":"dxNumberBox","editor-options":{
                    min: 0,
                    max: 10,
                    step: 0.1,
                    format: '#0.0',
                    showSpinButtons: true,
                    visible: _vm.chlorineDisabled,
                  },"visible":_vm.chlorineDisabled,"col-span":_vm.chlorineDisabled ? 3 : 1}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.freeResidualChlorine'),"visible":_vm.chlorineDisabled}})],1),_vm._v(" "),_c('DxItem',{attrs:{"editor-type":"dxSelectBox","data-field":"Articulo","is-required":true,"editor-options":{
                    disabled: _vm.analysisTypeDisabled,
                    dataSource: _vm.articlesBySubFamilia,
                    searchEnabled: true,
                    displayExpr: 'AtDescrip',
                    valueExpr: 'CodArticulo',
                    showClearButton: false,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class:
                          'standard-analysisType-select-dropdown',
                      },
                    },
                  },"validation-rules":[
                    {
                      type: 'required',
                      message: _vm.$t('fillRequiredFields'),
                    },
                  ],"col-span":_vm.chlorineDisabled ? 13 : 3}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.analysisType')}})],1),_vm._v(" "),_c('DxItem',{attrs:{"editor-type":"dxTextBox","data-field":"Sampler","col-span":_vm.chlorineDisabled ? 4 : 1}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.sampler')}})],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"lote","editor-type":"dxTextBox","col-span":_vm.chlorineDisabled ? 4 : 1,"editor-options":{
                    maxLength: 50,
                  }}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.lot')}})],1)],1),_vm._v(" "),_c('DxGroupItem',{attrs:{"col-count":1,"col-span":10}},[_c('DxItem',{attrs:{"data-field":"DescripcionMuestra","editor-type":"dxTextBox","is-required":true,"editor-options":{ height: 40, maxLength: 255 },"validation-rules":[
                    {
                      type: 'required',
                      message: _vm.$t('fillRequiredFields'),
                    },
                  ]}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.sampleDescription')}})],1)],1),_vm._v(" "),_c('DxGroupItem',{attrs:{"col-count":5,"col-span":10}},[_c('DxItem',{attrs:{"editor-type":"dxCheckBox","data-field":"cma","editor-options":{
                    disabled: false,
                    visible: _vm.checkCma,
                    value: _vm.cmaValue,
                  }}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.cmaEnabled'),"visible":_vm.checkCma,"location":"left"}})],1),_vm._v(" "),_c('DxItem',{attrs:{"editor-type":"dxSelectBox","data-field":"Legislacion","editor-options":{
                    disabled: false,
                    dataSource: _vm.legislations,
                    displayExpr: 'Legislacion',
                    valueExpr: 'idLegislacion',
                    visible: _vm.legislationVisible,
                  },"col-span":4}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.legislation'),"visible":_vm.legislationVisible}})],1)],1),_vm._v(" "),_c('DxGroupItem',{attrs:{"col-count":10,"col-span":10,"visible":_vm.hideSamplingPoints}},[_c('DxItem',{attrs:{"editor-type":"dxCheckBox","data-field":"automaticSamplingPoint","css-class":"sample-register-automatic-point","col-span":3,"editor-options":{
                    disabled: false,
                    visible: true,
                  },"label":{
                    text: _vm.$t(
                      'samplesRegister.automaticSamplingPoint'
                    ),
                    location: 'left',
                    visible: true,
                  }}}),_vm._v(" "),(_vm.formData.automaticSamplingPoint)?_c('DxItem',{attrs:{"data-field":"Parcelas","editor-type":"dxSelectBox","editor-options":{
                    disabled: _vm.fincaDisabled,
                    dataSource: _vm.farmsWithParcels,
                    displayExpr: 'Finca',
                    valueExpr: 'idFinca',
                    visible: true,
                    searchEnabled: true,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class: 'standard-finca-select-dropdown',
                      },
                    },
                  },"col-span":2}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.farm'),"visible":true}})],1):_c('DxItem',{attrs:{"data-field":"FincaLiteral","editor-type":"dxTextBox","editor-options":{
                    disabled: false,
                    visible: true,
                  },"col-span":2}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.farm'),"visible":true}})],1),_vm._v(" "),(_vm.formData.automaticSamplingPoint)?_c('DxItem',{attrs:{"data-field":"Parcela","editor-type":"dxSelectBox","editor-options":{
                    disabled: _vm.parcelaDisabled,
                    dataSource: _vm.filteredParcels,
                    displayExpr: 'Parcela',
                    valueExpr: 'idParcela',
                    visible: true,
                    searchEnabled: true,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class: 'standard-parcela-select-dropdown',
                      },
                    },
                  },"col-span":2}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.plot'),"visible":true}})],1):_c('DxItem',{attrs:{"data-field":"ParcelaLiteral","editor-type":"dxTextBox","editor-options":{
                    disabled: false,
                    visible: true,
                  },"col-span":2}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.plot'),"visible":true}})],1),_vm._v(" "),(_vm.formData.automaticSamplingPoint)?_c('DxItem',{attrs:{"data-field":"idNivelPunto","editor-type":"dxSelectBox","editor-options":{
                    disabled: !_vm.isLevelPointSelectionEnabled,
                    dataSource: _vm.filteredLevelPoints,
                    displayExpr: _vm.getLevelPointOptionText,
                    valueExpr: 'idNivelPunto',
                    visible: true,
                    searchEnabled: true,
                    placeholder: _vm.getLevelPointPlaceholder(),
                    showDropDownButton:
                      _vm.isLevelPointSelectionEnabled,
                    onValueChanged: _vm.handleLevelPointChange,
                    dropDownOptions: {
                      width: 620,
                      maxHeight: 320,
                      wrapperAttr: {
                        class:
                          'standard-levelPoint-select-dropdown',
                      },
                    },
                  },"col-span":2}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.pointCoordinate'),"visible":true}})],1):(false)?_c('DxItem',{attrs:{"data-field":"NivelPuntoCoordLiteral","editor-type":"dxTextBox","editor-options":{
                    disabled: false,
                    visible: true,
                    onValueChanged: _vm.handleLevelPointLiteralChange,
                  },"col-span":2}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.pointCoordinate'),"visible":true}})],1):_vm._e()],1),_vm._v(" "),_c('DxGroupItem',{attrs:{"col-count":5,"col-span":10}},[_c('DxItem',{attrs:{"editor-type":"dxCheckBox","data-field":"lmr","editor-options":{
                    disabled: false,
                    visible: _vm.checkLmr,
                    value: _vm.lmrValue,
                  }}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.lmrEnabled'),"visible":_vm.checkLmr,"location":"left"}})],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"trazaCultivo","editor-type":"dxCheckBox","editor-options":{
                    disabled: false,
                    visible: _vm.traceCultiveVisible,
                  }}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.trace'),"visible":_vm.traceCultiveVisible,"location":"left"}})],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"CultivoOrganico","editor-type":"dxCheckBox","editor-options":{
                    disabled: false,
                    visible: _vm.traceCultiveVisible,
                  }}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.organicFarming'),"visible":_vm.traceCultiveVisible,"location":"left"}})],1)],1),_vm._v(" "),_c('DxItem',{attrs:{"data-field":"Observaciones","editor-type":"dxTextArea","editor-options":{ height: 70, maxLength: 1000 },"col-span":10}},[_c('DxLabel',{attrs:{"text":_vm.$t('samplesRegister.sampleObservations')}})],1)],1)],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }